import * as _ from "lodash";
import {
    booleanSearchApiParamsToChipsObject,
    booleanSearchToString,
} from "app/pages/website-analysis/traffic-sources/search/booleanSearchUtility";
import DurationService from "app/services/DurationService";
import { TableTemplateV2 } from "../dashboard/TableTemplate-v2";
import IndustryKeywordsDashboardTableWidgetFilters from "../widget-filters/IndustryKeywordsDashboardTableWidgetFilters";
import { TableWidget } from "./TableWidget";
import { EKeywordTabs } from "app/UtilitiesAndConstants/Constants/SourceTypes";

export const getChannelValue = (channel, channelText) => {
    if (!channel) {
        return null;
    }
    if (channel === channelText || !channelText) {
        return channel;
    }
    return `${channel} ${channelText}`;
};

export class IndustryKeywordsDashboardTableWidget extends TableWidget {
    static getWidgetDashboardType() {
        return "Table";
    }

    static getWidgetMetadataType() {
        return "IndustryKeywordsDashboardTable";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    static getFiltersComponent() {
        return IndustryKeywordsDashboardTableWidgetFilters;
    }

    constructor() {
        super();
    }
    public getSearchKey() {
        return "SearchTerm";
    }

    getProperties() {
        const props = super.getProperties();
        return props;
    }

    parseFilters(filter) {
        return filter.split(/\s*,\s*/).reduce((parsedFilters, currentFilter) => {
            const parsed = /(\w+);(?:==|contains);(.+)/.exec(currentFilter);
            if (parsed) {
                let [, key, value] = parsed;
                let name;
                switch (key) {
                    case "Source":
                        name = "channel";
                        value = getChannelValue(value, this._widgetConfig.properties.filters.channelText);
                        break;
                    case "OP":
                        name = "tab";
                        switch (value) {
                            case "0":
                                value = "organic";
                                break;
                            case "1":
                                value = "paid";
                                break;
                            default:
                                value = "all";
                                break;
                        }
                        break;
                    case "SearchTerm":
                        name = "search";
                        value = value.replace(/'|"/g, "");
                        break;
                }
                return {
                    ...parsedFilters,
                    [name]: value,
                };
            }
            return parsedFilters;
        }, {});
    }

    getProUrl() {
        const { filter = "", includeBranded = "true", orderBy, IncludeTerms, ExcludeTerms } = this.apiParams;
        const parsedFilters = this.parseFilters(filter);
        const BooleanSearchTerms = booleanSearchToString(
            booleanSearchApiParamsToChipsObject({ ExcludeTerms, IncludeTerms }),
        );
        const topKeywordsUrlParams = {
            tab: "all",
            ...this._getProUrlParams(),
            excludeBranded: /false|true/.test(includeBranded) ? !JSON.parse(includeBranded) : false,
            ...parsedFilters,
            orderBy,
            BooleanSearchTerms,
        };
        return this._swNavigator.getStateUrl(
            this.getWidgetModel().metric === "SearchTrends"
                ? "market_research_demand_trends"
                : "findkeywords_byindustry_TopKeywords",
            topKeywordsUrlParams,
        );
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }

    protected rowReducer(row) {
        const requestParams = this._params;
        const stateParams = {
            isWWW: "*", //for now - until fix for subdomains-domains
            duration: DurationService.getDiffSymbol(
                requestParams.from,
                requestParams.to,
                requestParams.isWindow ? "days" : "months",
            ),
            country: requestParams.country,
        };
        const rowParams = _.clone(stateParams);

        if (requestParams.metric.toLowerCase().indexOf("paid") > -1) {
            row.Paid = 1;
        }
        const isPaid = row.OrganicPaid || row.Paid == 1;
        _.extend(rowParams, {
            keyword: row.SearchTerm,
            selectedPageTab: isPaid ? EKeywordTabs[EKeywordTabs.Paid] : EKeywordTabs[EKeywordTabs.Organic],
        });
        if (this.getWidgetModel().metric === "SearchTrends") {
            row.url = this._swNavigator.href("digitalsuite_marketresearch_keywordmarketanalysis_total", rowParams);
        } else {
            row.url = this._swNavigator.href("organicsearch_keywordAnalysis_2", rowParams);
        }
        return { ...row };
    }
}

IndustryKeywordsDashboardTableWidget.register();
